module.exports = __webpack_public_path__ + "ic-promo-code-import.svg?285e1a523d06c40073e57501f76da833";